<template>
    <section v-if="userStore.user.email && reportStore.reports[userStore.user.email].isReportFetch">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header p-0 mb-50 mx-auto">
                        <a class="go-back" @click="$router.go(-1)" >{{ localizationStore.translate("letter.create.back.button.text") }}</a>
                    </div>
                    <div class="card-content">
                        <div class="row match-height">
                            <div class="col-xl-12 col-lg-12">
                                <div class="card">
                                    <div v-if="lodash.size(dataFurnishers) > 0" class="card-body">
                                        <ul class="nav nav-tabs nav-justified" role="tablist">
                                            <li v-for="(furnisher, key) in dataFurnishers" class="nav-item">
                                                <a
                                                    class="nav-link"
                                                    :class="{ active: activeTab == key}"
                                                    @click="activeTab = key"
                                                >
                                                    {{ furnisher.furnisher.name }}
                                                </a>
                                            </li>
                                        </ul>
                                        <div class="tab-content pt-1">
                                            <div
                                                class="tab-pane active"
                                                role="tabpanel"
                                            >
                                                <div class="row">
                                                    <div class="col-12">
                                                        <h4>APPEND CLIENT DOCUMENTS</h4>
                                                        <div class="display-box mb-1">
                                                            <div class="ml-2">
                                                                <input
                                                                    class="custom-control-input"
                                                                    type="checkbox"
                                                                    name="append_affidavit"
                                                                    value="1"
                                                                    tabindex="4"
                                                                    v-model="checkbox"
                                                                    id="append_affidavit"

                                                                />
                                                                <label class="custom-control-label" for="Make_the_recipient_the_sender" @click="changeCheckbox">
                                                                    ID Theft Affidavit
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-for="(dataFurnisher, name) in dataFurnishers" :ref="name" hidden>
                                                    <sagestream-security-freeze v-if="$route.params.letter == letterStore.SECURITY_FREEZE_ATTACK" :data-furnisher='dataFurnisher.furnisher' />
                                                    <sagestream-request-for-disclosure v-else-if="$route.params.letter == letterStore.REQUEST_FOR_DISCLOSURE_ATTACK" :data-furnisher='dataFurnisher.furnisher' />
                                                    <sagestream-opt-out-pre-screen v-else-if="$route.params.letter == letterStore.OPT_OUT_PRE_SCREEN_ATTACK" :data-furnisher='dataFurnisher.furnisher' />
                                                </div>
                                                <div v-for="(furnisher, key) in dataFurnishers" v-show="activeTab == key">
                                                    <editor
                                                        :id="key"
                                                        v-model="furnisher.ref"
                                                        :api-key="settingStore.tinymce.api_key"
                                                        :init="settingStore.tinymce.configuration"
                                                    />
                                                </div>
                                                <div class="d-flex justify-content-center my-1">
                                                    <button class="btn btn-sm-block btn-primary" @click.once="submit" type="button" name="editorType" value="1">
                                                        {{ localizationStore.translate("letter.left.submit.button.text") }}
                                                    </button>
                                                    <button
                                                        id="letter-rewrite"
                                                        class="btn btn-outline-primary ml-1"
                                                        @click="spin"
                                                        type="button"
                                                    >
                                                        {{ localizationStore.translate("spin.letter.button.text") }}
                                                        <b-popover
                                                            target="letter-rewrite"
                                                            placement="top"
                                                            triggers="hover"
                                                            :html="true"
                                                        >
                                                            <template #title>
                                                                {{ localizationStore.translate("chat.pricing.title") }}
                                                            </template>
                                                            <div class="row">
                                                                <div class="col-12">
                                                                    <p v-if="planStore.openAI.serviceCharges.type == planStore.openAI.serviceCharges.fixed">
                                                                        {{ localizationStore.translate("chat.pricing.message", { credit: planStore.getPrice('letter_rewrite') }) }}
                                                                    </p>
                                                                    <p v-else>
                                                                        {{ localizationStore.translate("chat.pricing.dynamic.message") }}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </b-popover>
                                                    </button>
                                                    <button
                                                        data-toggle="modal"
                                                        data-target="#chat-modal"
                                                        class="btn btn-outline-primary mx-1"
                                                        type="button"
                                                    >
                                                        {{ localizationStore.translate("chat.button.title") }}
                                                    </button>
                                                    <button
                                                        data-toggle="modal"
                                                        data-target="#top-up-modal"
                                                        class="btn btn-outline-primary"
                                                        type="button"
                                                    >
                                                        {{ localizationStore.translate("spin.purchase.button.text") }}
                                                    </button>
                                                </div>
                                                <div class="row">
                                                    <spinner ref="spinner" :user-info='userStore.user' :editor-ref='editorRef' />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else class="card-body">
                                        <div class="alert alert-danger mt-1 alert-validation-msg" role="alert">
                                            <div class="alert-body">
                                                <i data-feather="info" class="mr-50 align-middle"></i>
                                                <span>
                                                    {{ localizationStore.translate("error.data.furnishers") }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
  import { ref, reactive, computed } from 'vue'
  import { useLocalizationStore } from '../../stores/LocalizationStore.js'
  import { useReportStore } from '../../stores/ReportStore.js'
  import { useUserStore } from '../../stores/UserStore.js'
  import { usePlanStore } from '../../stores/PlanStore.js'
  import { useSettingStore } from '../../stores/SettingStore.js'
  import moment from 'moment';
  import { useLetterStore } from '../../stores/LetterStore.js'
  import Editor from '@tinymce/tinymce-vue'
  import { BPopover } from 'bootstrap-vue-3'
  import lodash from 'lodash'

  export default {
    props: {
    },
    components: {
        'editor': Editor,
    },
    setup(props) {
        const reportStore = useReportStore();
        let dataFurnishers = reactive({});
        _.forEach(reportStore.filterDataFurnishers(1), function(dataFurnisher) {
            let furnisherName = dataFurnisher.name;
            if (furnisherName) {
                furnisherName = _.camelCase(furnisherName);
                if (_.isUndefined(dataFurnishers[furnisherName])) {
                    dataFurnishers[furnisherName] = {
                        furnisher: dataFurnisher,
                        ref: null
                    };
                }
            }
        });
        return {
            editorRef: ref(null),
            localizationStore: useLocalizationStore(),
            reportStore,
            userStore: useUserStore(),
            letterStore: useLetterStore(),
            planStore: usePlanStore(),
            settingStore: useSettingStore(),
            activeTab: ref(null),
            dataFurnishers,
            checkbox:ref(false),
            lodash: lodash,
            document:ref(),
            originalFile:ref([]),
            isSavingInfo:ref('')
        };
    },
    watch: {
        'userStore.user'(value) {
            if (value != null) {
                if (!this.reportStore.reports[value.email]) {
                    this.reportStore.getReport();
                }
                let $this = this;
                _.forEach(this.reportStore.filterDataFurnishers(1), function(dataFurnisher) {
                    let furnisherName = dataFurnisher.name;
                    if (furnisherName) {
                        furnisherName = _.camelCase(furnisherName);
                        if (_.isUndefined($this.dataFurnishers[furnisherName])) {
                            $this.dataFurnishers[furnisherName] = {
                                furnisher: dataFurnisher,
                                ref: null
                            };
                        }
                    }
                });
                $this.activeTab = _.head(_.keys($this.dataFurnishers));
            }
        },
    },
    created() {
    },
    mounted() {
        let $this = this;
        const letterSpinUrl = this.$router.resolve({
            name: 'spin-letter',
        });
        $this.$nextTick(() => {
            _.forEach($this.$refs, function(ref, key) {
                if (_.has($this.dataFurnishers, key)) {
                    $this.dataFurnishers[key].ref = ref[0].innerHTML;
                }
            });
            $this.activeTab = _.head(_.keys($this.dataFurnishers));
        });
    },
    updated() {
    },
    computed: {
    },
    methods: {
        submit() {
            const route = this.$router.resolve({
                name: 'create-letter',
                params: {
                    letter: this.$route.params.letter,
                    client: this.$route.params.client,
                    team: this.$route.params.team,
                }
            }),
            $this = this,
            payload = {
                multipe_letters: true,
                letters: []
            };
            _.forEach($this.dataFurnishers, function(furnisher) {
                payload.letters.push({
                    letter_id: $this.letterStore.getId($this.$route.params.letter),
                    credit_bureau_name: furnisher.furnisher.name,
                    letter_preview: furnisher.ref,
                    append_affidavit : $this.checkbox,
                });
            });
            axios.post(route.href, payload)
            .then(function (response) {
                if(response.data.error == true) {
                    toastr.error(response.data.message, 'Error!');
                    return;
                }
                toastr.success(response.data.message, 'Success!');
                setTimeout(() => {
                    if($this.userStore.user.isDIY){
                        $this.$router.push({ name: 'disputes-report' });
                        return;
                    }
                    window.location.href = response.data.data.url;
                }, 3000)
            })
            .catch(function (error) {
                console.log(error);
            });
        },
        spin() {
            this.$refs.spinner.spin(tinymce.get(this.activeTab))
        },
        changeCheckbox(){
            this.checkbox = !this.checkbox
        },
        updateLetter() {
            const $this = this;
            setTimeout(() => {
                _.forEach($this.$refs, function(ref, key) {
                    if (_.has($this.dataFurnishers, key)) {
                        $this.dataFurnishers[key].ref = ref[0].innerHTML;
                    }
                });
            }, 200);
        },
    }
  };
</script>
